<header class="sticky z-50 w-full">
  <nav
    class="flex flex-wrap items-center justify-between p-2 m-2 bg-gray-700 border border-gray-700 border-solid rounded-lg"
  >
    <!-- Always visible -->
    <div class="flex items-center flex-shrink-0 mr-6 text-white">
      <img class="w-8 h-8 mr-2 fill-current" src="/favicon.ico" alt="Logo" />
      <app-nav-link
        class="text-xl font-semibold text-teal-200 hover:text-orange-300"
        target="/"
      >
        STC2-DB
      </app-nav-link>
    </div>
    <!-- Button only visible if menu is collapsed -->
    <div class="block half-hd:hidden">
      <button
        class="flex items-center px-3 py-2 text-teal-200 border border-teal-400 rounded hover:text-orange-300"
        type="button"
        (click)="toggleMenu()"
      >
        <svg
          class="w-3 h-3 fill-current"
          viewBox="0 0 20 20"
          xmlns="http://www.w3.org/2000/svg"
        >
          <title>Menu</title>
          <path d="M0 3h20v2H0V3zm0 6h20v2H0V9zm0 6h20v2H0v-2z" />
        </svg>
      </button>
    </div>
    <!-- Menu content -->
    <div
      [ngClass]="{ hidden: isMenuHidden }"
      class="flex-grow block w-full half-hd:flex half-hd:items-center half-hd:w-auto"
      id="navbarSupportedContent"
    >
      <ul *ngIf="isUserOrAdmin$ | async" class="">
        <li class="block mt-4 mr-4 half-hd:inline-block half-hd:mt-0">
          <app-nav-link
            class="text-teal-200 hover:text-orange-300"
            target="/player/list"
          >
            Spielerliste
          </app-nav-link>
        </li>
        <li class="block mt-4 mr-4 half-hd:inline-block half-hd:mt-0">
          <app-nav-link
            class="text-teal-200 hover:text-orange-300"
            target="/alliance/list"
          >
            Allianzliste
          </app-nav-link>
        </li>
        <li class="block mt-4 mr-4 half-hd:inline-block half-hd:mt-0">
          <app-nav-link
            class="text-teal-200 hover:text-orange-300"
            target="/scan/list"
          >
            Subraum-Scans
          </app-nav-link>
        </li>
        <li class="block mt-4 mr-4 half-hd:inline-block half-hd:mt-0">
          <app-nav-link
            class="text-teal-200 hover:text-orange-300"
            target="/stellar-cartography"
          >
            Stellarkartographie
          </app-nav-link>
        </li>
        <li class="block mt-4 mr-4 half-hd:inline-block half-hd:mt-0">
          <app-nav-link
            class="text-teal-200 hover:text-orange-300"
            target="/changelog"
          >
            Changelog
          </app-nav-link>
        </li>
      </ul>
      <!-- above left aligned -->
      <div class="half-hd:flex-grow"></div>
      <!-- below right aligned -->
      <ul *ngIf="isAdmin$ | async" class="">
        <li class="block mt-4 mr-4 half-hd:inline-block half-hd:mt-0">
          <app-nav-link
            class="text-teal-200 hover:text-orange-300"
            target="/admin/overview"
          >
            Übersicht
          </app-nav-link>
        </li>
        <li class="block mt-4 mr-4 half-hd:inline-block half-hd:mt-0">
          <app-nav-link
            class="text-teal-200 hover:text-orange-300"
            target="/admin/user/list"
          >
            Benutzerliste
          </app-nav-link>
        </li>
      </ul>
      <button
        (click)="onLogout()"
        class="inline-block px-4 py-2 mt-4 leading-none text-white border border-white rounded half-hd:mt-0 hover:border-orange-300 hover:text-orange-300"
      >
        Abmelden
      </button>
    </div>
  </nav>
</header>
